// Types for the Agent Skills Editor feature.
// AgentFile and AgentFileVersion shapes match the agent_files /
// agent_file_versions migration columns 1:1.

export type AgentFileKind = "agent" | "skill" | "subskill";

export type TriggerOp = "equals" | "contains" | "gt" | "lt" | "regex";

export interface TriggerRule {
  field: string;
  op: TriggerOp;
  value: string | number;
}

export interface Frontmatter {
  name: string;
  description: string;
  trigger_type?: "description" | "rule";
  trigger_rule?: TriggerRule | null;
  /** Ontology spec §10: optional reference to an Object Type by api_name.
   * Drives the typed property dropdown for trigger_rule.field. */
  object_type_api_name?: string | null;
}

export interface AgentFile {
  id: string;
  parent_id: string | null;
  kind: AgentFileKind;
  name: string;
  /** Sibling display order (0-based). Lower values render first.
   * Added by migration 20260521400000; may be missing on stale cached rows. */
  position: number;
  frontmatter: Frontmatter;
  body: string;
  current_version: number;
  created_by: string | null;
  updated_by: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

export interface AgentFileVersion {
  id: string;
  agent_file_id: string;
  version_number: number;
  frontmatter: Frontmatter;
  body: string;
  note: string | null;
  created_by: string | null;
  created_at: string;
}

/** Tree node augmented with resolved children for UI rendering. */
export interface AgentFileNode extends AgentFile {
  children: AgentFileNode[];
}

/** Raised by useSaveAgentFile when the DB returns sqlstate P0001 (stale_version). */
export class StaleVersionError extends Error {
  constructor(message = "stale_version") {
    super(message);
    this.name = "StaleVersionError";
  }
}
